export default class Header {
  constructor({ text, type = 'h3' }) {
    this.component = type
    this.innerText = text
  }
}
